import { createStore } from 'vuex';

export default createStore({
    state: {
        showMessenger: false,
        initialChannel: null,
        csrfToken: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
    },
    mutations: {
        closeMessenger: (state) => {
            state.showMessenger = false;
        },
        openMessenger: (state, id = null) => {
            state.showMessenger = true;
            state.initialChannel = id;
        }
    },
});
